import { ReactNode } from 'react'
import * as FaIcons from 'react-icons/fa'
import * as Fa6Icons from 'react-icons/fa6'
import * as HiIcons from 'react-icons/hi'
import * as Hi2Icons from 'react-icons/hi2'
import * as MdIcons from 'react-icons/md'
import * as LuIcons from 'react-icons/lu'

// Admin enters icon names as plain strings (e.g. "FaUserTie",
// "HiCalendarDays", "MdCorporateFare"). We try each react-icons set in
// priority order based on the prefix and return null if nothing matches —
// the caller falls back to numbering the option (matching how Step 2 in
// the Figma renders unconfigured options as "1, 2, 3...").
export function resolveIcon(name: string | null | undefined, className?: string): ReactNode | null {
  if (!name) return null

  const sets: Record<string, Record<string, React.ComponentType<{ className?: string }>>> = {
    Fa6: Fa6Icons as never,
    Fa: FaIcons as never,
    Hi2: Hi2Icons as never,
    Hi: HiIcons as never,
    Md: MdIcons as never,
    Lu: LuIcons as never,
  }

  // Try the most specific prefix first (Fa6 before Fa, Hi2 before Hi).
  for (const [prefix, set] of Object.entries(sets)) {
    if (name.startsWith(prefix) && set[name]) {
      const IconComp = set[name]
      return <IconComp className={className} />
    }
  }

  // Fall back: try every set without prefix matching, in case admin
  // typed an icon name like "UserTie" without the "Fa" prefix.
  for (const set of Object.values(sets)) {
    if (set[name]) {
      const IconComp = set[name]
      return <IconComp className={className} />
    }
  }

  return null
}
